"Shoppad.apps.infiniteoptions".split(".").reduce(function(o, x) { if (!o[x]) {o[x] ={};} return o[x] }, window);
window.Shoppad.apps.infiniteoptions.beforeReady = function(subscribe) {  console.log('App beforeReady');

  subscribe('fieldLoad', function(event) {
    // console.log("event=", event);
    var values_list = event.detail.fieldConfig.values;
    var property_name = event.detail.name;
    var property_label = event.detail.fieldConfig.label;

    $.each(values_list, function(index, value){

      console.log("value=", value);
      var totalItems = values_list.length;
      var title = value.label;
      // var price = '';
      
      console.log("price=", price);
      console.log("value.variant=", value.variant);
      // if(value.variant != undefined)
      var price = (value.variant && value.variant.price > 0) ? value.variant.price : undefined;

      var swatch_find = '';
      try {
        swatch_find = $("input.spb-productoptiontextcolor[name='properties["+property_name+"]'][value='"+title+"']");
      }
      catch(err) {
        console.log("error=",err);
      }  
      if (swatch_find=='' || swatch_find==undefined || swatch_find.length <= 0){
        
          swatch_find = $("input.spb-productoptiontextcolor[type='checkbox'][value='"+title+"']");
          
      }

      (price!=undefined) ? swatch_find.parents(".spb-productoptionswatchwrapper").addClass("custom-swatch-style"): '';
      if (index > 14) { swatch_find.parents(".spb-productoptionswatchwrapper").addClass("visible_on_demand"); }
      swatch_find.parents('.spb-productoptionswatchwrapper').find('input').attr("price_value",title+((price!=undefined)?'|'+price:''));
      swatch_find.parents(".spb-productoptionswatchwrapper").find(".spb-productoptionswatch").after("<div class='details'><p>"+title+"</span></h6></div><span class='variant-price'>" +((price!=undefined)?( Shopify.formatMoney((price*100), money_format)):'') +"</span>");
      swatch_find.addClass(swatch_find.parents(".main_div").find(".spb-productdescfont").text().replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\ \\\/]/gi, ''));

      if (index === totalItems - 1 && totalItems > 15) {
        swatch_find.parents(".spb-option-values").after('<button class="btn options-toggle-btn view-more" type="button" aria-expanded="false"> View more </button>');
      }

      if(swatch_find.prop("checked") == true){
        console.log("selected_element = ", title);

        var selected_value = title;
      
        // var varSel = swatch_find;
        // var selected_value_from = property_label;
        var class_remove = property_label.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\ⓘ\ \\\/]/gi, '').trim();

        var attr_name = class_remove.replace(/ /g, "_");

          var img_url = value.swatch.value;
          console.log("img_url=",img_url);

        if(swatch_find.parents('.main_div').hasClass("change_selected_image")) {
          var img_url = value.swatch.value;
          console.log("img_url=",img_url);
          $(".product-selection-area .selected-product-block img#image_div").attr("src", img_url);
        }

        if(price != undefined){
          var current_money = $(".product-selection-area span.total_price").attr("price_money");
          //console.log("current_money =", current_money);
          var substract = $(".product-selection-area span.total_price").attr(attr_name.toLowerCase());
          
          var total_price = 0;
          if(current_money){
            var total_price = parseInt(current_money);
          }
          var price_money = '';
          
          if(substract){
              total_price = parseInt(current_money) - parseInt(substract);
          }
          
          var final_p = (Shopify.formatMoney(total_price*100 + (parseInt(price)*100), money_format));
        
          $(".product-selection-area span.total_price").attr("price_money", (total_price + parseInt(price)));
          $(".product-selection-area span.total_price").html(final_p+" INC GST");
          $(".product-selection-area span.total_price").attr(attr_name, price);
        } else {
          console.log("no price else section");
          swatch_find.parents('.spb-productoptionswatchwrapper').find('input').attr("price_value",title+((price!=undefined)?'|'+price:''));
          swatch_find.parents(".spb-productoptionswatchwrapper").find(".spb-productoptionswatch").after("<div class='details'><p>"+title+((price!=undefined && price != '')?( ' - '+Shopify.formatMoney((price*100), money_format)):'') +"</h6></div>");
          swatch_find.addClass(swatch_find.parents(".main_div").find(".spb-productdescfont").text().replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\ \\\/]/gi, ''));
          

        }

        $(".product-selection-area .selected-product-block ."+class_remove).remove();
        if(class_remove.indexOf("ChooseYourBaseVariant") >= 0){ //class_remove.indexOf("ChooseYourBaseVariant") >= 0
          $(".tt-swatches-container .tt-options-swatch li a[data-value='"+title+"']").trigger("click");
          $(".product-selection-area .selected-product-block h4.title").after("<div class='"+class_remove+"'><p class='"+class_remove+"'><strong>"+ property_label +":</strong></p><p class='"+class_remove+"'>"+ title +((Shopify.formatMoney((price*100), money_format)!='$0.00')?( ' - '+Shopify.formatMoney((price*100), money_format))+'':'') +"</p></div>");
        }
        else{
          $(".product-selection-area .selected-product-block").append("<div class='"+class_remove+"'><p class='"+class_remove+"'><strong>"+ property_label +":</strong></p><p class='"+class_remove+"'>"+ title +((price!=undefined)?( ' - '+Shopify.formatMoney((price*100), money_format)) : '' ) +"</p></div>");
          // $(".product-selection-area .selected-product-block").append("<div class='"+class_remove+"'><p class='"+class_remove+"'><strong>"+ property_label +":</strong></p><p class='"+class_remove+"'>"+ title +((price!=undefined)?( ' - '+Shopify.formatMoney((price*100), money_format))+'<span class="remove" remove-val="'+price+'" remove-div="'+class_remove+'">x</span>':'') +"</p></div>");
        }
            
      }

    });
  });
  

  subscribe('fieldChange1', function(event) {
    // console.log('fieldChange', event);

    var set_name = event.detail.name;
    var title = event.detail.value;
    // console.log("set_name=", set_name);
    // console.log("title=", title);

    var class_remove = set_name.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\ⓘ\ \\\/]/gi, '').trim();
    console.log("class_remove=", class_remove);

    $(".product-selection-area .selected-product-block ."+class_remove).remove();
    $(".product-selection-area .selected-product-block").append("<div class='"+class_remove+"'><p class='"+class_remove+"'><strong>"+ set_name +":</strong></p><p class='"+class_remove+"'>"+ title +"</p></div>");

    var target_element = event.target.activeElement;
    // console.log("target_element=", target_element);
    if($(target_element).parents(".main_div").hasClass("allow_multiple")){
      console.log("allow_multiple");
    }

  });

  subscribe('productBundleAdd1', function(event) {
    // console.log('productBundleAdd', event);

    var title = event.detail.name;
    var price = event.detail.productBundle.price;
    var class_remove = title.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\ⓘ\ \\\/]/gi, '').trim();

    if(price != ''){
      //console.log("price add=", price);
      var current_money = $(".product-selection-area span.total_price").attr("price_money");
      // console.log("current_money =", current_money);
      var substract = $(".product-selection-area span.total_price").attr(class_remove.toLowerCase());
      // console.log("substract =", substract);
      var total_price = 0;
      if(current_money){
        var total_price = parseInt(current_money);
      }
      var price_money = '';
        if(substract != '' && substract != undefined){
          total_price = parseInt(current_money) - parseInt(substract); //(parseInt(current_money) - parseInt(substract)) + parseInt(product.price);
        }
      var final_p = (Shopify.formatMoney(total_price*100 + (parseInt(price)*100), money_format));
      
      $(".product-selection-area span.total_price").attr("price_money", (total_price + parseInt(price))); //(total_price - product.price)? total_price : 0
      
      $(".product-selection-area span.total_price").html(final_p+" INC GST");
      
      $(".product-selection-area span.total_price").attr(class_remove, price);
      
    }

  });

};
  
$(document).on("click", ".options-toggle-btn", function(){
  if ($(this).hasClass("view-less")){
    $('html').animate({
      scrollTop: $(this).parents(".main_div").offset().top
    }, 800);
  } // $(this).parents(".main_div").scrollIntoView() : '' ;
  $(this).toggleClass("expanded");
  $(this).parents(".main_div").find(".spb-option-values").toggleClass("visible_all");
  $(this).hasClass("expanded")? $(this).text("View Less").addClass("view-less").removeClass("view-more") : $(this).text("View More").addClass("view-more").removeClass("view-less");
});

document.addEventListener("DOMContentLoaded", function() {

$(document).on("change", ".tt-swatches-container-js1 a.options-color", function(){
  var data_val = $(this).attr("data-value");
  // console.log("data_val=",data_val);
//   $("div.ChooseYourBaseVarient .ChooseYourBaseVarient_value").html(data_val+" - ")
});

if(!$("body").hasClass("productwith-dropdown-selection")){
$(document).on("change", "#infiniteoptions-container .main_div:not(.allow_multiple) input", function(){
  var full_val = $(this).attr('price_value');
  // console.log("full_val=", full_val);
  //var handle = (full_val.split("|")[0])?full_val.split("|")[0]:full_val;
  var title = '',
      price = 0;
  if (full_val != undefined){
   title = (full_val.split("|")[0])?full_val.split("|")[0]:full_val;
   price = (full_val.split("|")[1])?full_val.split("|")[1]:'';
  }
  //console.log(title);
  var selected_input = $(this).attr("name");
  var selected_value = full_val;//$(this).val();
  
  var varSel = $(this);
  var selected_value_from = $(this).parents(".main_div").find(".spb-productdescfont:not(.spb-tooltip)").text();//$(this).parents("div[role=group]").find(".spb-productdescfont").text();
  //var class_remove = selected_value_from.replace(/\(.*?\)/g, '').trim();       
  var class_remove = selected_value_from.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\ⓘ\ \\\/]/gi, '').trim();

  if(class_remove.indexOf("ChooseYourBaseVariant") >= 0){
    class_remove = 'ChooseYourBaseVariant'; //$(".product-selection-area .selected-product-block .ChooseYourBaseVariant").remove();
  }
  
  //var attr_name = class_remove.replace(/ /g, "_");
        
  
  if(varSel.parents('.main_div').hasClass("change_selected_image")) { //console.log("change img");
    var bg_image = varSel.parents(".spb-productoptionswatchwrapper").find(".spb-productoptionswatch").css("background-image").replace("url", "");
    
    var img_url = bg_image.substring(bg_image.indexOf('("') + 1, bg_image.indexOf('")'));
    
    //console.log("bg_image=", img_url);
    $(".product-selection-area .selected-product-block img#image_div").attr("src", img_url.replace(/"/g, "")); 
  }
  $(".product-selection-area .selected-product-block ."+class_remove).remove();
  
  $( "#infiniteoptions-container input.spb-productoptiontextcolor:checked" ).each(function( index ) { //console.log("change productoptiontextcolor");
                                                                                      
    if($(this).prop("checked") == true){
        if(price != ''){
          //console.log("price add=", price);
          var current_money = $(".product-selection-area span.total_price").attr("price_money");
          //console.log("current_money =", current_money);
          var substract = $(".product-selection-area span.total_price").attr(class_remove);
          // console.log("substract =", substract);
          var total_price = 0;
          if(current_money){
          	var total_price = parseInt(current_money);
          }
          var price_money = '';
            if(substract != '' && substract != undefined){
              total_price = parseInt(current_money) - parseInt(substract); //(parseInt(current_money) - parseInt(substract)) + parseInt(product.price);
            }
          var final_p = (Shopify.formatMoney(total_price*100 + (parseInt(price)*100), money_format));
          
          $(".product-selection-area span.total_price").attr("price_money", (total_price + parseInt(price))); //(total_price - product.price)? total_price : 0
          
          $(".product-selection-area span.total_price").html(final_p+" INC GST");
         
          $(".product-selection-area span.total_price").attr(class_remove, price);
          
        }
      
      }
    
  });
  
  $(".product-selection-area .selected-product-block ."+class_remove).remove();
  if(class_remove.indexOf("ChooseYourBaseVariant") >= 0){
    $(".product-selection-area .selected-product-block .ChooseYourBaseVariant").remove();
  }
  if(class_remove.indexOf("ChooseYourBaseVariant") >= 0){
    //$("")
    console.log("Base Variant Title=", title);
    $(".tt-swatches-container .tt-options-swatch li a[data-value='"+title+"']").trigger("click");
    $(".product-selection-area .selected-product-block h4.title").after("<div class='"+class_remove+"'><p class='"+class_remove+"'><strong>"+ selected_value_from +":</strong></p><p class='"+class_remove+"'>"+ title +((Shopify.formatMoney((price*100), money_format)!='$0.00')?( ' - '+Shopify.formatMoney((price*100), money_format))+'':'') +"</p></div>");
  }
  else{
    if(title != '' && title != undefined)
  	$(".product-selection-area .selected-product-block").append("<div class='"+class_remove+"'><p class='"+class_remove+"'><strong>"+ selected_value_from +":</strong></p><p class='"+class_remove+"'>"+ title +((Shopify.formatMoney((price*100), money_format)!='$0.00')?( ' - '+Shopify.formatMoney((price*100), money_format)) :'') +"</p></div>");
  }
});
}

$(document).on("change", "#infiniteoptions-container .main_div.allow_multiple input", function(){
  if($('body').hasClass('productsample-box')){
    var selected_value_from = $(this).parents(".main_div").find(".spb-productdescfont:not(.spb-tooltip)").text();
    var attr_name = selected_value_from.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\ \\\/]/gi, '').trim();
    var current_money = $(".product-selection-area span.total_price").attr("price_money");
  	$(".product-selection-area .selected-product-block ."+attr_name).remove();
    var selected_val = $(this).parents(".main_div").find("input[type=hidden]").val().split(",");//$(this).val().split(",");
//     console.log('selected_val=', selected_val);
    if(selected_val.length >= 0 && selected_val != ''){
      for (var i = 0; i < selected_val.length; i++){ 
        var full_val = selected_val[i];
        var title = (full_val.split("|")[0])?full_val.split("|")[0]:full_val;
        if(title != '' && title != undefined){ // console.log("code with remove btn");
              $(".product-selection-area .selected-product-block").append("<div class='"+attr_name+"'><p class='"+attr_name+"'><strong>"+ selected_value_from +":</strong></p><p class='"+attr_name+"'>"+ title +"<span class='remove' attr_val='"+title+"' remove_type='checkbox' remove-div='"+attr_name+"'>x</span></p></div>");
        }
      }
    }
    
  } else {
  var selected_value_from = $(this).parents(".main_div").find(".spb-productdescfont:not(.spb-tooltip)").text();
  var attr_name = selected_value_from.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\ \\\/]/gi, '').trim();
  var current_money = $(".product-selection-area span.total_price").attr("price_money");
        
  var total_price = 0;
  if(current_money){
    var total_price = parseInt(current_money);
  }
  var price_money = '';
  if(attr_name.indexOf("ChooseYourBaseVariant") >= 0){
    attr_name = 'ChooseYourBaseVariant'; //$(".product-selection-area .selected-product-block .ChooseYourBaseVariant").remove();
  }
        
  $(".product-selection-area .selected-product-block ."+attr_name).remove();
  //var handle = (full_val.split("|")[0])?full_val.split("|")[0]:full_val;
  if($(this).prop("checked") == true){
    
    //console.log("selected_val=",$(this));  
    var all_selected = $(this).parents('fieldset').find('input[type=hidden]').attr('price_value');
    $(this).parents('fieldset').find('input[type=hidden]').attr("price_value",((all_selected!=undefined)?all_selected:'')+","+$(this).attr('price_value'));

        var full_val = $(this).attr("price_value");//$(this).val()//selected_val[i];
        console.log("title with issue=", full_val);
        var title = (full_val.split("|")[0])?full_val.split("|")[0]:full_val;
        var price = (full_val.split("|")[1])?full_val.split("|")[1]:'';

        var checkbox_val = $(this).parents(".allow_multiple").find("input[type='hidden']").val();
        if(price != ''){
          var final_p = (Shopify.formatMoney(total_price*100 + (parseInt(price)*100), money_format));
          $(".product-selection-area span.total_price").attr("price_money", (total_price + parseInt(price))); //(total_price - product.price)? total_price : 0

          $(".product-selection-area span.total_price").html(final_p+" INC GST");

          $(".product-selection-area span.total_price").attr(attr_name, price);
        }
    }
  
    if($(this).prop("checked") == false){

      var all_selected = $(this).parents('fieldset').find('input[type=hidden]').attr('price_value').split(",");
      //console.log("selected checkboxes=",all_selected);
      all_selected.splice($.inArray($(this).attr('price_value'), all_selected), 1);
      //console.log("selected checkboxes removed=",all_selected);
      $(this).parents('fieldset').find('input[type=hidden]').attr("price_value",all_selected);

  //     var all_selected = $(this).parents('fieldset').find('input[type=hidden]').attr('price_value_all');
  //     $(this).parents('fieldset').find('input[type=hidden]').attr("price_value",all_selected+","+$(this).attr('price_value'));
      var full_val = $(this).attr("price_value");//$(this).val();//$("");
      var title = (full_val.split("|")[0])?full_val.split("|")[0]:full_val;
      var price = (full_val.split("|")[1])?full_val.split("|")[1]:'';
      //console.log("unchecked price=", price);

      if(price != '') {
        var val_unchecked = $(this).val().split("|");
        var current_money = $(".product-selection-area span.total_price").attr("price_money");
        //$(".product-selection-area .selected-product-block div span.[attr_val='"+val_unchecked[0]+"]").click();
        total_price = parseInt(current_money) - parseInt(price);
  
        var final_p = (Shopify.formatMoney(total_price*100, money_format));
        $(".product-selection-area span.total_price").attr("price_money", total_price); //(total_price - product.price)? total_price : 0
  
        $(".product-selection-area span.total_price").html(final_p+" INC GST");
  
        $(".product-selection-area span.total_price").attr(attr_name, price);
      }
    }

    if($(this).parents(".main_div").find("input[type=hidden]").length > 0) {
      var selected_val = $(this).parents(".main_div").find("input[type=hidden]").attr('price_value').split(",");//$(this).val().split(",");
  
      if(selected_val.length >= 0 && selected_val != ''){//console.log("add p");
        //var add_val_ = "<div class='"+attr_name+"'><p><strong>"+ selected_value_from +":</strong></p>";
        for (var i = 0; i < selected_val.length; i++){ 
          var full_val = selected_val[i];
  
          var title = (full_val.split("|")[0])?full_val.split("|")[0]:full_val;
          var price = (full_val.split("|")[1])?full_val.split("|")[1]:'';
          //console.log("title=", title);
          //console.log("price=", price);
          if(title != '' && title != undefined){
            $(".product-selection-area .selected-product-block").append("<div class='"+attr_name+"'><p class='"+attr_name+"'><strong>"+ selected_value_from +":</strong></p><p class='"+attr_name+"'>"+ title +((Shopify.formatMoney((price*100), money_format)!='$0.00')?( ' - '+Shopify.formatMoney((price*100), money_format)) : '' ) +"</p></div>");
            //add_val_ += "<p class="+attr_name+i+">"+ title +((Shopify.formatMoney((price*100), money_format)!='$0.00')?( ' - '+Shopify.formatMoney((price*100), money_format))+'<span class="remove" attr_val="'+title+'" remove-val="'+price+'" remove-div="'+attr_name+i+'">x</span>':'') +"</p>";
          }
        }
      }
    }
      
  }
});

$(document).on("click", ".product-selection-area .selected-items .remove", function(){
  //console.log("remove");
  if($('body').hasClass('productsample-box')){
  	var remove = $(this).attr('attr_val');
    var remove_div = $(this).attr("remove-div");
    $("#infiniteoptions-container .allow_multiple input[value='"+remove+"']").prop("checked", false);
    $(this).parents(".product-selection-area .selected-items div."+remove_div).remove();
  }
  else{
    var remove_div = $(this).attr("remove-div");

    if($(this).attr("remove_type")=="checkbox"){
      var remove = $(this).attr('attr_val');
      var whole_title_price = $(this).attr('attr_val')+"|"+$(this).attr('remove-val');
      //console.log("remove=",remove);
      var all_selected = $("#infiniteoptions-container .allow_multiple input[value='"+remove+"']").parents('fieldset').find('input[type=hidden]').attr('price_value').split(",");
      var new_val = $("#infiniteoptions-container .allow_multiple input[value='"+remove+"']").parents('fieldset').find('input[type=hidden]').val().split(",");

      all_selected.splice($.inArray(whole_title_price, all_selected), 1);
      new_val.splice($.inArray(remove, new_val), 1);
      //console.log("selected checkboxes removed=",all_selected);
      //$(this).parents('fieldset').find('input[type=hidden]').attr("price_value",all_selected);
      $("#infiniteoptions-container .allow_multiple input[value='"+remove+"']").parents('fieldset').find('input[type=hidden]').attr("price_value",all_selected);
      $("#infiniteoptions-container .allow_multiple input[value='"+remove+"']").parents('fieldset').find('input[type=hidden]').val(new_val);


      $("#infiniteoptions-container .allow_multiple input[value='"+remove+"']").prop("checked", false);
    }else{
      $('input.'+remove_div).prop('checked', false);
    }

    $(this).parents(".product-selection-area .selected-items div."+remove_div).remove();//$(".product-selection-area .selected-items div.AddAccessories").children().length
    //console.log("len=", $(".product-selection-area .selected-items div"+remove_div).children().length);
    //if($(".product-selection-area .selected-items div"+remove_div).children().length <= 1 ){console.log("all blank");$(".product-selection-area .selected-items div."+remove_div).remove();}

    var price = $(this).attr("remove-val");
    var attr_name = $(this).attr("remove-div");
    if(price != ''){
      //console.log("price add=", price);
      var current_money = $(".product-selection-area span.total_price").attr("price_money");
      //console.log("current_money =", current_money);
      var substract = $(".product-selection-area span.total_price").attr(attr_name);
      //console.log("substract =", substract);
      var total_price = parseInt(current_money);
      var price_money = '';
      if(substract != '' && substract != undefined){
        total_price = parseInt(current_money) - parseInt(substract); //(parseInt(current_money) - parseInt(substract)) + parseInt(product.price);
      }

      var final_p = (Shopify.formatMoney(total_price*100, money_format));

      $(".product-selection-area span.total_price").attr("price_money", total_price); //(total_price - product.price)? total_price : 0

      $(".product-selection-area span.total_price").html(final_p+" INC GST");

      $(".product-selection-area span.total_price").attr(attr_name, price);

      // console.log("attr_name=",attr_name);
      // console.log("price=",price);

      if($('.product-selection-area .selected-items div.'+attr_name.toLowerCase()).length <= 0){$(".product-selection-area span.total_price").removeAttr(attr_name);}
    }

  }
});

$(document).on("click", ".main_div.checkbox p.show_hide_options", function(e){ // e.preventDefault();
    $(this).parents(".main_div.checkbox").toggleClass("expand");
    $(this).parents(".main_div.checkbox").find(".show_more").toggleClass("hide");
    $(this).parents(".main_div.checkbox").find(".show_less").toggleClass("hide");
});

if($("body").hasClass("productwith-dropdown-selection")){
  window.Shoppad.apps.infiniteoptions.beforeReady = function(subscribe) {

    subscribe('appLoad', function(event) {
      $(".main_div.checkbox").append("<p class='show_hide_options show_more'>Show More Options</p><p class='show_hide_options show_less hide'>Show Less Options</p>");
    });
    
      /**
   * @param {object} event
   * @param {string} event.detail.name The field name of the input.
   * @param {object} event.detail.element A jQuery object representing the element that added to the DOM (this is the parent <div> that wraps the input and label).
   * @param {object} event.detail.productBundle Details about the bundled product.
   */
    subscribe('productBundleAdd', function(event) {
      // Note: The product variant price returned is cached. You may want to retrieve the latest price.
      window.Shoppad.apps.infiniteoptions.getLatestVariantPrice(event.detail.productBundle, function(productBundle) {
//         console.log(Shopify.formatMoney((event.detail.productBundle.price), money_format));
//         console.log('Latest productBundle price add=', event.detail.productBundle);
        
        fetch('/products/' + event.detail.productBundle.handle + '.js').then(function(response){ return response.json() }).then( 
          function(product){
            let variant = product.variants.find(function(variant){ return variant.id == event.detail.productBundle.variantId })
           
            var curr_pr = parseFloat($(".tt-price span.actual-price").attr("price"));
            curr_pr = curr_pr/100;
            var var_p = parseFloat(variant.price/100);
            var newp = curr_pr+var_p;
            if (newp > 0){
              var selected_val_price = 0;
              if($("[name='properties["+event.detail.productBundle.name+"]']").parents(".main_div").hasClass("checkbox")){
                var selected_val_price = $("[name='properties["+event.detail.productBundle.name+"]']").attr("selected-var-price");
//                 console.log("selected_val_price=",selected_val_price);
              	$("[name='properties["+event.detail.productBundle.name+"]']").attr("selected-var-price", ((selected_val_price!=undefined)?parseFloat(selected_val_price):0) +var_p);
              } else {
              	$("[name='properties["+event.detail.productBundle.name+"]']").attr("selected-var-price", var_p);
              }
              $(".tt-price span.actual-price").text(Shopify.formatMoney((newp*100), money_format));
              $(".tt-price span.actual-price").attr("price", newp*100);
            }
            
            var curr_compareatpr = parseFloat($(".tt-price span.old-price").attr("c_price"));
            curr_compareatpr = curr_compareatpr/100;
            var compareatp = parseFloat(variant.compare_at_price/100);
            var newcompareatp = curr_compareatpr+compareatp;
//             console.log("compareatp=",compareatp);
            if (newcompareatp > 0){
              if($("[name='properties["+event.detail.productBundle.name+"]']").parents(".main_div").hasClass("checkbox")){
                var selected_val_cprice = $("[name='properties["+event.detail.productBundle.name+"]']").attr("selected-compareat-price");
//                 console.log("selected_val_cprice=",selected_val_cprice);
                if(compareatp > 0)$("[name='properties["+event.detail.productBundle.name+"]']").attr("selected-compareat-price", ((selected_val_cprice!=undefined)?parseFloat(selected_val_cprice):0) +compareatp);
              } else {
                $("select[name='properties["+event.detail.productBundle.name+"]']").attr("selected-compareat-price", compareatp);
              }
              $(".tt-price span.old-price").attr("c_price", newcompareatp*100);
              $(".tt-price span.old-price").text(Shopify.formatMoney((newcompareatp*100), money_format));
            }
            
            if(newcompareatp > newp){$(".tt-price span.old-price").removeClass("hide");}else{$(".tt-price span.old-price").addClass("hide");}
           
           
          }
        );
        
      });
    });
    
      /**
   * @param {object} event
   * @param {string} event.detail.name The field name of the input.
   * @param {object} event.detail.element A jQuery object representing the element that added to the DOM (this is the parent <div> that wraps the input and label).
   * @param {object} event.detail.productBundle Details about the bundled product.
   */
    subscribe('productBundleRemove', function(event) {
     
      window.Shoppad.apps.infiniteoptions.getLatestVariantPrice(event.detail.productBundle, function(productBundle) {

        fetch('/products/' + event.detail.productBundle.handle + '.js').then(function(response){ return response.json() }).then( 
          function(product){
            let variant = product.variants.find(function(variant){ return variant.id == event.detail.productBundle.variantId })
           
            var curr_pr = parseFloat($(".tt-price span.actual-price").attr("price"));
            curr_pr = curr_pr/100;
            var var_p = parseFloat(variant.price/100); //parseFloat(event.detail.productBundle.price);
           
            var newp = curr_pr-var_p;
            if (newp > 0){
             
              var selected_val_price = 0;
              if($("[name='properties["+event.detail.productBundle.name+"]']").parents(".main_div").hasClass("checkbox")){
                var selected_val_price = $("[name='properties["+event.detail.productBundle.name+"]']").attr("selected-var-price");
//                 console.log("selected_val_price=",selected_val_price);
              	$("[name='properties["+event.detail.productBundle.name+"]']").attr("selected-var-price", ((selected_val_price!=undefined)?parseFloat(selected_val_price):0) -var_p);
              }
              $(".tt-price span.actual-price").text(Shopify.formatMoney((newp*100), money_format));
              $(".tt-price span.actual-price").attr("price", newp*100);
            }
            
            var curr_compareatpr = parseFloat($(".tt-price span.old-price").attr("c_price"));
            curr_compareatpr = curr_compareatpr/100;
            var compareatp = parseFloat(variant.compare_at_price/100);
            var newcompareatp = curr_compareatpr-compareatp;
            
            var selected_val_cprice = 0;
            if (newcompareatp > 0){
              if($("[name='properties["+event.detail.productBundle.name+"]']").parents(".main_div").hasClass("checkbox")){
                var selected_val_cprice = $("[name='properties["+event.detail.productBundle.name+"]']").attr("selected-compareat-price");
//                 console.log("selected_val_cprice=",selected_val_cprice);
                $("[name='properties["+event.detail.productBundle.name+"]']").attr("selected-compareat-price", ((selected_val_cprice!=undefined)?parseFloat(selected_val_cprice):0) -compareatp);
              }
              $(".tt-price span.old-price").attr("c_price", newcompareatp*100);
              $(".tt-price span.old-price").text(Shopify.formatMoney((newcompareatp*100), money_format));
            }
            
            if(newcompareatp > newp){$(".tt-price span.old-price").removeClass("hide");}else{$(".tt-price span.old-price").addClass("hide");}
            
          }
        );
        
        
      });
    });

  };
}
  });